// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"12be6834","125":"183d597f","498":"188be547","513":"9df13c35","703":"18f9c91d"}[chunkId] + ".chunk.js";
};